import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { CircleAlert } from "lucide-react";
import { useAuth } from "@/auth";
import { api, formatApiError } from "@/api";

export default function EmailAccess() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { loginWithToken, logout } = useAuth();
  const [error, setError] = useState(null);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    // Cualquier sesión previa (p. ej. de otro restaurante) se reemplaza
    logout();
    api
      .post("/auth/email-link", { token })
      .then(({ data }) => {
        loginWithToken(data.token, data.user);
        navigate(`/admin/${data.user.restaurant_id}`, { replace: true });
      })
      .catch((err) =>
        setError(formatApiError(err, "Este enlace no es válido o ha caducado.")),
      );
  }, [token, loginWithToken, logout, navigate]);

  return (
    <div className="relative min-h-screen bg-[#FDFBF7] text-[#1C1917] flex items-center justify-center px-5">
      <div className="ambient-glow" />
      <div className="grain-overlay" />
      <div className="relative z-10 text-center" data-testid="email-access-page">
        {error ? (
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            className="flex flex-col items-center gap-4"
            data-testid="email-access-error"
          >
            <CircleAlert className="h-8 w-8 text-[#C25E38]" />
            <h1 className="font-serif-display text-2xl font-medium tracking-tight">
              No se pudo abrir el panel
            </h1>
            <p className="text-sm text-[#57534E] max-w-xs">{error}</p>
            <button
              type="button"
              data-testid="email-access-login-button"
              onClick={() => navigate("/login", { replace: true })}
              className="text-sm font-medium rounded-xl px-5 py-3 bg-[#1C1917] text-[#FDFBF7] hover:bg-[#C25E38] transition-colors duration-300 cursor-pointer"
            >
              Ir a iniciar sesión
            </button>
          </motion.div>
        ) : (
          <p
            data-testid="email-access-loading"
            className="font-mono-label text-[10px] uppercase tracking-[0.3em] text-[#A8A29E] animate-pulse"
          >
            Abriendo tu panel...
          </p>
        )}
      </div>
    </div>
  );
}
